import {PHASES, WAR_PHASE_STAGES} from "../../constants/phases";

export const getPhaseDurationMs = (phase, warStage, isFastMode = false) => {
  let turnDurationSec;

  switch (phase) {
    case PHASES.SETUP:
      turnDurationSec = 60;
      break;
    case PHASES.SUPPLY:
      turnDurationSec = 20;
      break;
    case PHASES.CONSTRUCTION:
      turnDurationSec = 30;
      break;
    case PHASES.WAR:
      switch (warStage) {
        case WAR_PHASE_STAGES.RECRUITMENT:
          turnDurationSec = 20;
          break;
        case WAR_PHASE_STAGES.MOVEMENT:
          turnDurationSec = 20;
          break;
        case WAR_PHASE_STAGES.ABILITIES:
          turnDurationSec = 20;
          break;
        case WAR_PHASE_STAGES.SHOOTING:
          turnDurationSec = 20;
          break;
        case WAR_PHASE_STAGES.COMBAT:
          turnDurationSec = 20;
          break;
        case WAR_PHASE_STAGES.MANEUVER:
          turnDurationSec = 10;
          break;
        default:
      }
      break;
    default:
  }

  const baseMs = turnDurationSec * 1000 * 2;
  return isFastMode ? baseMs / 2 : baseMs;
}